import { Injectable } from '@angular/core';
import { SessionStorageService } from '../../services/session-storage.service';
import { ShipmentExperienceMode } from './shipment-experience.model';

@Injectable({ providedIn: 'root' })
export class ShipmentModePreferenceService {
    constructor(private sessionStorage: SessionStorageService) {}

    get(defaultMode: ShipmentExperienceMode = 'ADVANCED'): ShipmentExperienceMode {
        const stored = window.localStorage.getItem(this.key());
        return stored === 'SIMPLE' || stored === 'ADVANCED' ? stored : defaultMode;
    }

    set(mode: ShipmentExperienceMode): void {
        window.localStorage.setItem(this.key(), mode);
    }

    private key(): string {
        const companyId = this.sessionStorage.getCompany()?.id ?? 'default';
        const customerId = this.sessionStorage.getCustomer()?.id ?? 'anonymous';
        return `shipment-experience-mode:${companyId}:${customerId}`;
    }
}
